<script>
import RoundedBox from '@/components/RoundedBox.vue';

export default {
  name: 'Card',

  components: {
    RoundedBox,
  },

  props: {
    cardId: {
      type: String,
      default: '',
    },
    cardDraft: {
      type: Object,
      default: null,
    },
    currentId: {
      type: String,
      default: '',
    },
    setHeight: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    savedCard() {
      return this.$store.state.cards.allCards[this.cardId];
    },

    card() {
      const { cardId, cardDraft, $store } = this;
      if (cardDraft) {
        return cardDraft;
      }

      let card = this.savedCard;
      if (!card) {
        card = {
          id: '',
          title: '',
          subtitle: '',
          text: '',
          category: 'journey',
          type: 'free',
        };
      }
      return card;
    },
  },

  watch: {
    savedCard: {
      handler(card) {
        const { currentId, cardId, setHeight } = this;
        if (card && currentId === cardId) {
          this.$nextTick(() => {
            setHeight(cardId);
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <RoundedBox
    fullscreen
    :title="card.title || 'loading'"
    :subtitle="card.subtitle"
    h1
    center-title
    justify-start
    class="card"
  >
    <div class="card-container">
      <v-skeleton-loader v-if="!card.text" type="text@10, sentences"> </v-skeleton-loader>
      <div class="text">
        <p v-for="(p, index) in card.text.split('\n')" :key="index">
          {{ p }}
        </p>
      </div>
    </div>
  </RoundedBox>
</template>

<style lang="scss" scoped>
.card {
  .landing & {
    width: 320px;
    min-height: 580px;
    height: fit-content;
  }
}

.text {
  flex: 1;
  text-indent: 1.5em;
  text-align: justify;
}
</style>
